import React from "react";
import { CheckoutButton } from "./CheckoutButton";
export function FinalCta() {
  return <section className="px-4 py-14 sm:px-5 sm:py-20" data-id="element-42" data-mp="vfplgdgiody7">
      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-gold bg-panel p-6 text-center sm:p-10" data-id="element-43" data-mp="vh0ryl1cjzt0">
        <h2 className="font-display text-3xl uppercase leading-tight text-cream sm:text-5xl" data-id="element-44" data-mp="19cuqqb8ep8se">
          Votre prochain cours peut être <span className="text-gold" data-id="element-45" data-mp="1jcvc02pu5yz8">prêt aujourd'hui.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-lg text-mute sm:text-lg" data-id="element-46" data-mp="1jasbgor24ng9">
          2 livres et 5 bonus prêts à l'emploi. Ouvrez, choisissez, enseignez. Tout pour 27 $ US, avec 10 jours de garantie.
        </p>
        <CheckoutButton label="Je veux le pack complet — 27 $ US" className="mt-7 w-full sm:w-auto" data-id="element-47" data-mp="1t4r9bbk3ll2e" />
      </div>
    </section>;
}